import { Button, Divider, Form, Input, Space, Tooltip } from 'antd'
import { LineItemImage } from '../../LineItemImage'
import TextArea from 'antd/es/input/TextArea'
import { SupplierInput } from '../SupplierInput'
import { Clock, ExternalLink, Hash, Link2, Tag } from 'lucide-react'
import { LineItem } from '../../../../types/ffe'
import { useFFEStore } from '../../../../store/ffeStore'

export const ProductPanel = ({ item }: { item: LineItem }) => {
  const updateLineItem = useFFEStore((state) => state.updateLineItem)
  const handleUpdate = (updates: Partial<LineItem>) => {
    updateLineItem(item.id, updates)
  }
  return (
    <div className="overflow-y-auto p-6 max-h-[calc(100vh-110px)]">
      <div className="space-y-6">
        {/* Summary Section */}
        <div>
          <div className="flex gap-4 mb-4">
            <div>
              <LineItemImage item={item} onUpdate={handleUpdate} />
            </div>
          </div>
        </div>

        {/* Item Details */}
        <Form layout="vertical">
          <Form.Item label="Client Item Title">
            <Input
              value={item.name}
              onChange={(e) => handleUpdate({ name: e.target.value })}
              placeholder="Enter item title"
            />
          </Form.Item>

          <Form.Item label="Client Item Description">
            <TextArea
              value={item.description}
              onChange={(e) => handleUpdate({ description: e.target.value })}
              placeholder="Enter item description"
              rows={3}
            />
          </Form.Item>

          <Form.Item label="Internal Notes">
            <TextArea
              value={item.internalNotes}
              onChange={(e) => handleUpdate({ internalNotes: e.target.value })}
              placeholder="Add internal notes about this item"
              rows={4}
            />
          </Form.Item>

          <Space className="w-full" size="large">
            <Form.Item label="Supplier" className="flex-1">
              <SupplierInput
                value={item.supplier}
                onChange={(value) => handleUpdate({ supplier: value })}
              />
            </Form.Item>

            <Form.Item label="SKU/Product Code" className="flex-1">
              <Input
                value={item.supplierItemCode}
                onChange={(e) =>
                  handleUpdate({ supplierItemCode: e.target.value })
                }
                placeholder="Enter SKU"
                prefix={<Hash className="h-4 w-4 text-gray-400" />}
              />
            </Form.Item>
          </Space>

          <Form.Item label="Lead Time">
            <Input
              value={item.leadTime}
              onChange={(e) => handleUpdate({ leadTime: e.target.value })}
              placeholder="Enter lead time"
              prefix={<Clock className="h-4 w-4 text-gray-400" />}
            />
          </Form.Item>

          <Form.Item label="Brand">
            <Input
              value={item.brand}
              onChange={(e) => handleUpdate({ brand: e.target.value })}
              placeholder="Enter brand name"
              prefix={<Tag className="h-4 w-4 text-gray-400" />}
            />
          </Form.Item>

          <Form.Item label="Product URL">
            <Space.Compact className="w-full">
              {item.productUrl && (
                <Tooltip title="Open product page">
                  <Button
                    icon={<ExternalLink className="h-4 w-4" />}
                    onClick={() => window.open(item.productUrl, '_blank')}
                  />
                </Tooltip>
              )}
              <Input
                key={'productUrl'}
                value={item.productUrl}
                onChange={(e) => handleUpdate({ productUrl: e.target.value })}
                placeholder="Enter product URL"
                prefix={<Link2 className="h-4 w-4 text-gray-400" />}
              />
            </Space.Compact>
          </Form.Item>
        </Form>

        <Divider />

        {/* Attachments Section */}
        {/* <div>
            <Title level={5}>Attachments</Title>
            <Text type="secondary" className="block mb-4">
              Upload files related to this item (specifications, datasheets,
              etc.)
            </Text>

            <Upload.Dragger multiple showUploadList={false}>
              <p className="ant-upload-drag-icon">
                <FileUp className="h-8 w-8 mx-auto text-gray-400" />
              </p>
              <p className="ant-upload-text">Click or drag files to upload</p>
            </Upload.Dragger>

            {item.attachments && item.attachments.length > 0 && (
              <div className="mt-4 space-y-2">
                {item.attachments.map((file) => (
                  <div
                    key={file.id}
                    className="flex items-center gap-2 p-2 border rounded hover:bg-gray-50"
                  >
                    <FileText className="h-4 w-4 text-gray-400" />
                    <div className="flex-1 min-w-0">
                      <Text className="block truncate">{file.name}</Text>
                      <Text type="secondary" className="text-xs">
                        {(file.size / 1024).toFixed(1)} KB
                      </Text>
                    </div>
                    <Button
                      type="text"
                      danger
                      size="small"
                      onClick={() =>
                        handleUpdate({
                          attachments: item.attachments?.filter(
                            (f) => f.id !== file.id
                          )
                        })
                      }
                    >
                      Remove
                    </Button>
                  </div>
                ))}
              </div>
            )}
          </div> */}
      </div>
    </div>
  )
}
